import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EquipmentStatus, EquipmentCondition } from "dora-contracts";
import { Equipment } from "../../data/equipment/types";
import * as dataActions from "../../data/equipment";

const prefix = "app/equipment-dialog";

export type FormData = {
  id?: string;
  equipmentTypeId: string | null;
  number: string | null;
  serialNumber: string | null;
  quantity: number;
  status: EquipmentStatus;
  condition: EquipmentCondition;
  ownWeight: string | null;
  depotId: string | null;
  homeLocation: string | null;
  homeLat: number | null;
  homeLon: number | null;
  note: string | null;
};

type State = {
  open: boolean;
  initialFormData: FormData | null;
};

const initialState: State = {
  open: false,
  initialFormData: null,
};

export const getEmptyFormData = (): FormData => ({
  equipmentTypeId: null,
  number: null,
  serialNumber: null,
  quantity: 1,
  status: "AVAILABLE",
  condition: "GOOD",
  ownWeight: null,
  depotId: null,
  homeLocation: null,
  homeLat: null,
  homeLon: null,
  note: null,
});

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {
    addEquipment(state) {
      state.open = true;
      state.initialFormData = getEmptyFormData();
    },
    editEquipment(state, action: PayloadAction<Equipment>) {
      state.open = true;
      state.initialFormData = { ...action.payload };
    },
    close(state) {
      state.open = false;
      state.initialFormData = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(dataActions.addEquipment.fulfilled, (state) => {
      state.open = false;
      state.initialFormData = null;
    });
    builder.addCase(dataActions.updateEquipment.fulfilled, (state) => {
      state.open = false;
      state.initialFormData = null;
    });
  },
});

export default slice.reducer;
export const { addEquipment, editEquipment, close } = slice.actions;
